import { render, staticRenderFns } from "./OptionMealsEditing.vue?vue&type=template&id=d4db0970&"
import script from "./OptionMealsEditing.vue?vue&type=script&lang=js&"
export * from "./OptionMealsEditing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports